<div class="calculator-container">
    @if (buildingService.loading() && !buildingService.levels().length) {
        <div class="spinner-overlay flex items-center justify-center">
            <ca-spinner [transparent]="true" [text]="'RBR.ROOM_LIST.LOADER_TEXT' | translate" />
        </div>
    }
    @if (buildingService.error()) {
        <div class="wrapper error-state-wrapper flex items-center justify-center flex-col">
            <img class="room-by-room-error mb-3" src="/assets/ca-images/error-cross.png" alt="" />
            <h3 class="mb-4">{{ 'RBR.LOADING_ERROR' | translate }}</h3>
            <p class="ca-text-md mb-5">{{ 'RBR.LOADING_ERROR_DESCRIPTION' | translate }}</p>
            <button mat-flat-button class="ca-button ca-button-s" (click)="loadProjectLevels()">
                <span> {{ 'RBR.TRY_AGAIN' | translate }} </span>
            </button>
        </div>
    } @else if (!buildingService.levels().length) {
        <div class="wrapper empty-state-wrapper flex items-center justify-center flex-col">
            <img class="room-by-room-logo mb-3" src="/assets/ca-images/room-by-room-logo.png" alt="" />
            <h3 class="mb-4">{{ 'RBR.START' | translate }}</h3>
            <p class="ca-text-md mb-5">{{ 'RBR.START_DESCRIPTION' | translate }}</p>

            <button mat-flat-button class="ca-button ca-button-s" (click)="addUpperLevel(true)">
                <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon><span> {{ 'RBR.LEVEL_LIST.ADD_ROOMS' | translate }} </span>
            </button>
        </div>
    } @else {
        @let calcSummary = buildingService.calculationSummary();
        @let isLeftoverAreaNegative = calcSummary && calcSummary.leftoverArea < 0;
        <div class="mb-4 wrapper">
            <div class="results">
                <span class="cooling-load"
                    ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_COOLING_LOAD' | translate }}</span>
                    <span class="ca-bold ms-2 calculation-value"
                        >{{ calcSummary?.totalCoolingLoad | rbrNumber }} {{ 'MEASUREMENT_UNITS.KW' | translate }}</span
                    >
                </span>
                <span class="heat-load"
                    ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_HEAT_LOAD' | translate }}</span>
                    <span class="ca-bold ms-2 calculation-value"
                        >{{ calcSummary?.totalHeatLoad | rbrNumber }} {{ 'MEASUREMENT_UNITS.KW' | translate }}</span
                    ></span
                >
                @if (calcSummary?.includeTotalBuilding && calcSummary?.totalLivingArea) {
                    <div class="divider"></div>
                    <span class="living-area"
                        ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.TOTAL_LIVING_AREA' | translate }}</span>
                        <span class="ca-bold ms-2 calculation-value"
                            >{{ calcSummary?.totalLivingArea | rbrNumber }} {{ 'MEASUREMENT_UNITS.M2' | translate }}</span
                        ></span
                    >
                    <span class="leftover-area negative-value flex items-center" [class.negative-value]="isLeftoverAreaNegative"
                        ><span class="ca-text-tertiary">{{ 'RBR.LEVEL_LIST.SUMMARY.LEFTOVER_AREA' | translate }}</span>
                        <span class="ca-bold ms-2 calculation-value"
                            >{{ calcSummary?.leftoverArea | rbrNumber }} {{ 'MEASUREMENT_UNITS.M2' | translate }}</span
                        >
                        @if (isLeftoverAreaNegative) {
                            <ca-icon icon="cross-circle" class="ca-icon-s-24-p-0-f-24 ca-icon-danger ms-2"></ca-icon>
                        }
                    </span>
                }
            </div>
            <ca-rbr-calculation-base
                class="ml-auto"
                [calculationBase]="buildingService.calculationBase()"
                (confirm)="onCalculationBaseConfirm($event)"
            />
        </div>
        @if (calcSummary?.totalLivingArea && isLeftoverAreaNegative) {
            <ca-message
                id="negative-leftover-area"
                [message]="{
                    type: messageType.Error,
                    content: 'RBR.NOTIFICATIONS.NEGATIVE_LEFTOVER_AREA' | translate
                }"
                class="block mb-6"
            ></ca-message>
        }
        <ca-rbr-default-values [defaultValues]="buildingService.defaultValues()" (confirm)="onDefaultValuesConfirm($event)" />

        <div class="levels-container">
            @if (buildingService.loading()) {
                <div class="spinner-overlay flex items-center justify-center">
                    <ca-spinner [transparent]="true" [text]="'RBR.ROOM_LIST.LOADER_TEXT' | translate" />
                </div>
            }
            <div class="flex items-center justify-center mb-2 wrapper pseudo-button" (click)="addUpperLevel()">
                <button #addUpperLevelButton mat-button class="ca-button ca-button-xs md:my-auto">
                    <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.ADD_UPPER_LEVEL' | translate }}</span>
                </button>
            </div>
            @for (level of buildingService.levels(); track level.id) {
                <ca-rbr-level-rooms-panel
                    class="block mb-2"
                    [levels]="buildingService.levels()"
                    [level]="level"
                    [openAddRooms]="openAddRooms"
                    (toggleHeating)="toggleHeating($event)"
                    (toggleCooling)="toggleCooling($event)"
                    (deleteLevel)="deleteLevel(level.id)"
                    (deleteRoom)="deleteRoom($event)"
                    (setRooms)="setRooms($event)"
                ></ca-rbr-level-rooms-panel>
            }
            <div class="flex items-center justify-center wrapper pseudo-button" (click)="addLowerLevel()">
                <button #addLowerLevelButton mat-button class="ca-button ca-button-xs md:my-auto">
                    <ca-icon icon="big-plus" class="ca-icon-s"></ca-icon> <span>{{ 'RBR.BUTTON.ADD_LOWER_LEVEL' | translate }}</span>
                </button>
            </div>
        </div>
    }
</div>
